// @flow

import React from "react";
import ReactModal from "react-modal";
import styles from "./Modal.scss";
import Icon from "../Icon";
import Button from "../button/Button";

type Props = {
  isOpen: boolean,
  disabled: boolean,
  children: any,
  closeModal: Function,
  contentLabel: string,
  overlayClassName: string,
  modalInnerClassName: string,
  modalClass: string,
  cancelBtnLabel: string,
  submitBtnLabel: string,
  dialogTitle: string,
  onSubmit: Function,
  onCancel: Function,
  alertBox: boolean,
  dialogBox: boolean,
  warning: boolean
};

const Modal = (props: Props) => {
  const {
    children = null,
    isOpen,
    closeModal,
    overlayClassName = "",
    modalInnerClassName = "",
    contentLabel,
    cancelBtnLabel = "Cancel",
    submitBtnLabel,
    onSubmit,
    alertBox,
    dialogBox,
    dialogTitle,
    onCancel,
    warning,
    modalClass,
    submitDisabled
  } = props;
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel={contentLabel}
      className={`${alertBox || dialogBox ? styles.alertBox : ""} ${
        styles.modal
      } ${modalClass}`}
      overlayClassName={`${overlayClassName} ${styles.overlay}`}
      shouldCloseOnOverlayClick={true}
      onRequestClose={() => closeModal()}
      ariaHideApp={false}
    >
      <div className={`${modalInnerClassName} ${styles.modalInner}`}>
        {!alertBox ? (
          <div className={styles.closeIcon} onClick={() => closeModal()}>
            <Icon name="back-arrow" />
          </div>
        ) : (
          ""
        )}
        {dialogBox && dialogTitle ? (
          <div className={styles.title}>{dialogTitle}</div>
        ) : (
          ""
        )}
        {children}
        {dialogBox ? (
          <div className={styles.btnWrapper}>
            <Button
              className={`${styles.btn} ${styles.cancelBtn}`}
              variant="transparent"
              onClick={onCancel ? onCancel : () => closeModal()}
            >
              {cancelBtnLabel}
            </Button>

            <Button
              className={styles.btn}
              variant={warning ? "filledWarning" : "primary"}
              onClick={onSubmit}
              disabled={submitDisabled}
            >
              {submitBtnLabel}
            </Button>
          </div>
        ) : (
          ""
        )}
      </div>
    </ReactModal>
  );
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/common/modal/Modal.js